import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { ArrowLeftIcon, } from '@phosphor-icons/react';
import MainContainer from 'components/MainContainer';
import LoadingOverlay from 'components/LoadingOverlay';
import { getUser } from 'api/users';

export default function Utente() {

    const { userId } = useParams();

    const { data, isLoading } = useQuery({
        queryKey: ["utenti", userId],
        queryFn: () => getUser({ userId: userId }),
        enabled: !!userId
    });

    return (
        <>
            <LoadingOverlay isLoading={isLoading} />

            <MainContainer>
                <div className='pt-10 pb-5'>
                    <div className='flex gap-4 items-center justify-between'>
                        <Link className='w-[80px] h-[50px] bg-white flex items-center justify-center rounded-[20px] cursor-pointer hover:bg-verylight' to="/impostazioni/utenti">
                            <ArrowLeftIcon size={24} className="inline-block" />
                        </Link>

                        <Link to={`/impostazioni/utenti/${userId}/modifica`} className='h-[50px] bg-main text-white rounded-[20px] px-6 flex items-center justify-center gap-2 cursor-pointer font-normal hover:bg-black transition-all'>
                            Modifica
                        </Link>
                    </div>
                </div>

                <div className='flex gap-4 items-start'>
                    <div className='flex-1'>
                        <div className='bg-white rounded-[20px] border border-grey'>
                            <div className='px-5 py-4'>
                                <div>
                                    <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                                        <div>
                                            <p className='text-sm text-grey mb-1'>Nome</p>
                                            <p className='text-base font-medium'>{data?.name}</p>
                                        </div>
                                        <div>
                                            <p className='text-sm text-grey mb-1'>Email</p>
                                            <p className='text-base font-medium'>{data?.emails?.[0]?.address}</p>
                                        </div>
                                        <div>
                                            <p className='text-sm text-grey mb-1'>Admin</p>
                                            <p className='text-base font-medium'>{data?.superuser ? "Sì" : "No"}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </MainContainer>
        </>
    )
}
